<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="服务名称">
          <el-input placeholder="请输入服务名称" v-model="formInline.search">
        
          </el-input>
        </el-form-item>

        <el-form-item label="区域">
          <el-select v-model="formInline.province_id" placeholder="省" @change="initCity">
            <el-option :label="item.name" :value="item.id" v-for="(item,index) in areaList" :key='index'></el-option>
          </el-select>
          <el-select v-if="formInline.province_id!=''" v-model="formInline.city_id" placeholder="市" @change="initRegion">
            <el-option :label="item1.name" :value="item1.id" v-for="(item1,index1) in areaList[formInline.province_id]['city']"
              :key='index1'></el-option>
          </el-select>
          <el-select v-if="formInline.city_id!=''" v-model="formInline.region_id" placeholder="区">
            <el-option :label="item2.name" :value="item2.id" v-for="(item2,index2) in areaList[formInline.province_id]['city'][formInline.city_id]['region']"
              :key='index2'></el-option>
          </el-select>


      </el-form-item>
        <el-form-item >
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
          <el-button type="primary" icon="el-icon" @click="reast">重置</el-button>
        </el-form-item>

      </el-form>
    </div>

    <!-- <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加服务</el-button>
    </div> -->

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="service_id" label="ID"></el-table-column>  
            <el-table-column prop="product.product_name" label="产品"></el-table-column>
            <el-table-column prop="name" label="服务名称"></el-table-column>
            <el-table-column prop="linkman" label="联系人"></el-table-column>
            <el-table-column prop="phone" label="联系电话"></el-table-column>
            <el-table-column prop="expiration_date" label="到期时间"></el-table-column>
            <el-table-column prop="num" label="购买次数"></el-table-column>

            <el-table-column prop="region.province" label="省"></el-table-column>
            <el-table-column prop="region.city" label="市"></el-table-column>
            <el-table-column prop="region.region" label="区"></el-table-column>

            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <!-- <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button> -->
                <el-button @click="txClick(scope.row)" type="text" size="small">提醒到期</el-button>
                <el-button @click="declareClick(scope.row)" type="text" size="small">申报</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :service_id="service_id"  v-if="open_edit"   @close="closeEdit"></Edit>

    <Index :open_info="declare_status" :obj="obj" v-if="declare_status"   @close="closeDeclare"></Index>
    
  </div>
</template>

<script>
  import ServiceApi from '@/api/service.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';
  import Index from './declare/index.vue';
  import select_region from '@/utils/select.district.js';

  export default {
    components: {
      Add,
      Edit,
      Index,
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:"",
          province_id:0,
          city_id:0,
          region_id:0,
          region_search:"",
        },

        open_add:false,
        open_edit:false,
        service_id:"",
        dialogVisible:false,
        declare_status:false,
        obj:{},
         /*省市区*/
        areaList: select_region,
      };
    },
    created() {

      /*获取列表*/
      this.getTableList();
    },
    methods: {
      reast(){
      this.formInline =  {
          search:"",
          province_id:0,
          city_id:0,
          region_id:0,

        },
      this.getTableList();
    },
      declareClick(e){
        this.obj = e;
        this.declare_status = true;
      },
      closeDeclare(){
        this.declare_status = false;
      },
      dialogFormVisible(){
        this.dialogVisible = false;
      },
      setting(e){//服务标题设置
        // this.categorya_id = e
        this.dialogVisible = true;
      },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        ServiceApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.service_id = row.service_id;
        this.open_edit = true
      },
      txClick(row) {
        let self = this;
        self
          .$confirm('是否提醒', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            ServiceApi.tx(
              {
                service_id: row.service_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '提醒成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      },
      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            ServiceApi.del(
              {
                service_id: row.service_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      },
        /*初始化城市id*/
    initCity() {
        this.formInline.city_id = ''
      },
      /*初始化区id*/
      initRegion() {
        this.formInline.region_id = ''
      },
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/service/index/index.vue